"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCompanyBrandingRequest = exports.companyBrandingResponse = exports.companyLogoInfo = exports.logoContentType = exports.LOGO_MAX_BYTES = exports.DEFAULT_COMPANY_BRANDING = exports.companyBranding = exports.companyAddress = exports.invoiceTemplate = exports.phoneNumber = exports.hexColor = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
/**
 * هوية الشركة على مستنداتها المطبوعة: العنوان والتواصل والألوان وقالب الفاتورة.
 * منفصلة عن `companySettings` لأنها لا تحكم أى ترحيل — تغييرها لا يمس قيدًا ولا رقمًا،
 * وما يُطبع بعده فقط يتغير شكله. اللوجو له مسار رفع خاص (بايتات لا JSON).
 */
/** لون كامل بست خانات — الطباعة والتباين يحتاجان قيمة محددة لا اسمًا ولا اختصارًا. */
exports.hexColor = zod_1.z
    .string()
    .trim()
    .regex(/^#[0-9a-fA-F]{6}$/, 'color must be #RRGGBB')
    .transform((value) => value.toLowerCase());
const optionalText = (max) => zod_1.z
    .string()
    .trim()
    .max(max)
    .transform((value) => (value === '' ? null : value))
    .nullable()
    .default(null);
/** رقم تليفون كما يُكتب: أرقام ومسافات و+ و- وأقواس فقط — لا تحقق من شبكة بعينها. */
exports.phoneNumber = zod_1.z
    .string()
    .trim()
    .regex(/^\+?[\d\s()-]{5,24}$/, 'phone must be digits with optional + - ( ) and spaces');
exports.invoiceTemplate = zod_1.z.enum(['classic', 'modern']);
exports.companyAddress = zod_1.z.object({
    line1: optionalText(200),
    line2: optionalText(200),
    city: optionalText(100),
    governorate: optionalText(100),
});
exports.companyBranding = zod_1.z.object({
    address: exports.companyAddress.default({}),
    phones: zod_1.z.array(exports.phoneNumber).max(3).default([]),
    email: zod_1.z
        .string()
        .trim()
        .email()
        .max(200)
        .nullable()
        .or(zod_1.z.literal('').transform(() => null))
        .default(null),
    website: optionalText(200),
    /** شروط الدفع أو بيانات الحساب البنكى — تُطبع أسفل كل فاتورة وإشعار. */
    invoiceFooter: optionalText(1000),
    colors: zod_1.z
        .object({
        primary: exports.hexColor.default('#1f4e79'),
        secondary: exports.hexColor.default('#c9a227'),
    })
        .default({}),
    invoiceTemplate: exports.invoiceTemplate.default('classic'),
});
exports.DEFAULT_COMPANY_BRANDING = exports.companyBranding.parse({});
/** حد اللوجو — الصورة تُخزَّن فى القاعدة لا على القرص، فالحد يحمى حجم النسخ الاحتياطى. */
exports.LOGO_MAX_BYTES = 500 * 1024;
exports.logoContentType = zod_1.z.enum(['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml']);
exports.companyLogoInfo = zod_1.z.object({
    contentType: exports.logoContentType,
    byteSize: zod_1.z.number().int(),
    /** بصمة المحتوى — ETag للمسار، والواجهة تضيفها لعنوان الصورة فتتجدد عند التغيير. */
    sha256: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.companyBrandingResponse = zod_1.z.object({
    companyId: common_1.uuid,
    branding: exports.companyBranding,
    logo: exports.companyLogoInfo.nullable(),
    updatedAt: zod_1.z.string().nullable(),
});
/** الحفظ كامل كالإعدادات: ما لم يُرسل يعود افتراضيًا. اللوجو لا يمر من هنا. */
exports.updateCompanyBrandingRequest = zod_1.z
    .object({
    branding: exports.companyBranding,
})
    .strict();
//# sourceMappingURL=branding.js.map